var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelicopter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1355_1127)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 20,
    r: 13,
    fill: "#F2F2F2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8 13.95C18.8 13.4245 19.2245 13 19.75 13H31.15C31.6754 13 32.1 13.4245 32.1 13.95C32.1 14.4755 31.6754 14.9 31.15 14.9H26.4V16.8H27.35C29.9743 16.8 32.1 18.9256 32.1 21.55V23.45C32.1 23.9755 31.6754 24.4 31.15 24.4H26.4H24.025C23.7251 24.4 23.4431 24.2605 23.265 24.02L20.7 20.6L16.4012 18.8811C16.1192 18.7683 15.9054 18.5248 15.8312 18.228L15.1484 15.4908C15.0712 15.1909 15.2998 14.9 15.6086 14.9H16.425C16.7248 14.9 17.0068 15.0395 17.185 15.28L18.325 16.8H24.5V14.9H19.75C19.2245 14.9 18.8 14.4755 18.8 13.95ZM26.4 22.5H30.2V21.55C30.2 19.9766 28.9234 18.7 27.35 18.7H26.4V22.5ZM33.7209 25.6291C34.092 26.0002 34.092 26.6028 33.7209 26.9739L33.6051 27.0897C32.8926 27.8022 31.9248 28.203 30.9184 28.203H22.6C22.0745 28.203 21.65 27.7784 21.65 27.253C21.65 26.7275 22.0745 26.303 22.6 26.303H30.9184C31.4231 26.303 31.907 26.1041 32.2632 25.7478L32.379 25.632C32.7501 25.2609 33.3528 25.2609 33.7239 25.632L33.7209 25.6291Z",
    fill: "#132439"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1355_1127",
    x: 12,
    y: 7,
    width: 26,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1355_1127"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelicopter);
export default __webpack_public_path__ + "static/media/helicopter.58fc885f8a215f40188a603d2b45c830.svg";
export { ForwardRef as ReactComponent };